import { getThemeComponentClasses } from "@/src_new/shared/lib/themeComponentClasses";
import BrandLogo from "./BrandLogo";

type HeaderBrandProps = {
  variant?: "default" | "header" | "sidebar";
};

export default function HeaderBrand({ variant = "default" }: HeaderBrandProps) {
  const componentClasses = getThemeComponentClasses();
  const textClassName =
    variant === "header"
      ? componentClasses?.header?.brandTextColor
      : variant === "sidebar"
        ? componentClasses?.sidebar?.brandTextColor
        : "";

  return <BrandLogo textClassName={textClassName || undefined} />;
}
